// Système de statut Instapharm (couleurs du design_guidelines).
export const STATUS_META = {
  ouvert: { label: "Ouvert", bg: "bg-[#DCFCE7]", text: "text-[#166534]", dot: "bg-[#22C55E]", pulse: true },
  appeler_avant: { label: "Appeler avant", bg: "bg-[#FEF3C7]", text: "text-[#92400E]", dot: "bg-[#F59E0B]" },
  complet: { label: "Complet", bg: "bg-[#FEF3C7]", text: "text-[#92400E]", dot: "bg-[#F59E0B]" },
  ferme_exceptionnellement: { label: "Fermé except.", bg: "bg-[#F1F5F9]", text: "text-[#475569]", dot: "bg-[#94A3B8]" },
  __verifier: { label: "Se renseigner", bg: "bg-[#F3F4F6]", text: "text-[#6B7280]", dot: "bg-[#9CA3AF]", dashed: true },
};

export function statusMeta(status) {
  return STATUS_META[status] || STATUS_META.__verifier;
}

export const StatusPill = ({ status, testid }) => {
  const m = statusMeta(status);
  return (
    <span
      data-testid={testid || `status-pill-${status || "unknown"}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wide ${m.bg} ${m.text} ${m.dashed ? "border border-dashed border-[#9CA3AF]" : ""}`}
    >
      <span className="relative flex h-2 w-2">
        {m.pulse && <span className={`absolute inline-flex h-full w-full rounded-full ${m.dot} opacity-75 animate-ping`} />}
        <span className={`relative inline-flex rounded-full h-2 w-2 ${m.dot}`} />
      </span>
      {m.label}
    </span>
  );
};

// Rendu d'une donnée : valeur réelle OU « à vérifier » (jamais inventé).
export const OrVerify = ({ value, testid }) =>
  value ? (
    <span data-testid={testid}>{value}</span>
  ) : (
    <span data-testid={testid} className="italic text-[#9CA3AF]">à vérifier</span>
  );
